import { render, staticRenderFns } from "./laboratory.vue?vue&type=template&id=bb5b6cfa"
import script from "./laboratory.vue?vue&type=script&lang=js"
export * from "./laboratory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports